<template>
  <div>
    <el-dialog :title="editingId?'编辑订单':'添加订单'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
      <div v-loading="fullscreenLoading" class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :model="form" label-position="right" label-width="120px">
            <template>
              <el-form-item label="下单人信息：" prop="name" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                <el-select v-model="form.name" placeholder="根据手机号/姓名搜索" filterable clearable remote :remote-method="searchUsers" :loading="loading" @change="getUserAddr">
                  <el-option v-for="(it,idx) in userList" :label="`${it.name}(${it.pho})${it.levelName}`" :key="idx" :value="it.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单类型：" class="width100" prop="orderType" :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                <el-radio-group v-model="form.orderType">
                  <el-radio :label="10">内购订单</el-radio>
                  <el-radio :label="20">售后退返订单</el-radio>
                  <el-radio :label="30">其他</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="收货地址：" prop="addr" :rules="[{ required: true, message: '请选择收货地址', trigger: 'change' }]">
                <div class="flexs">
                  <el-select v-model="form.addr" placeholder="请选择收货地址" clearable>
                    <el-option v-for="(it,idx) in userAddrList" :key="idx" :label="it.allAddr" :value="it.id"></el-option>
                  </el-select>
                  <el-button type="primary" @click="addAddress">新增地址</el-button>
                </div>
              </el-form-item>
              <el-form-item label="随货同行单：" prop="companyName" :rules="[{ required: true, message: '请选择随货同行单', trigger: 'change' }]">
                <el-select v-model="form.companyName" placeholder="请选择随货同行单" clearable>
                  <el-option v-for="(it,idx) in customerCertificatesList" :key="idx" :label="it.companyName" :value="it.companyName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注：" class="width100">
                <el-input v-model="form.msg" placeholder="请输入备注" />
              </el-form-item>
              <el-form-item label="支付方式：" prop="orderPayType" :rules="[{ required: true, message: '请选择支付方式', trigger: 'change' }]">
                <el-radio-group v-model="form.orderPayType" @change="changeRatio">
                  <el-radio :label="4">赠送支付<br /><span v-if="userWallet" class="pays">剩余：￥{{userWallet.tuition}}</span></el-radio>
                  <el-radio :label="1">零售价支付<br /><span v-if="userWallet" class="pays">剩余：￥{{userWallet.xiaoduMoney}}</span></el-radio>
                  <el-radio :label="2">余额支付<br /><span v-if="userWallet" class="pays">剩余：￥{{userWallet.balance}}</span></el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="price-notice">
                价格规则：余额=身份折扣价 | 零售价=零售价 | 学费=零售价×0.75
              </div>
              <el-form-item label="优惠折扣：" class="width100">
                <el-input placeholder="按平台规则自动生成" v-model="form.discount" disabled>
                  <template slot="append">折</template>
                </el-input>
                <span class="hint">由下单人身份与支付方式按平台规则自动带出，不支持手工修改</span>
              </el-form-item>
              <el-form-item label="订货商品：" class="width100">
                <div class="table-list mt20">
                  <div class="spec-head">
                    <div class="sp-col flex2">商品</div>
                    <div class="sp-col">规格</div>
                    <div class="sp-col">市场价</div>
                    <div class="sp-col">折扣</div>
                    <div class="sp-col">数量</div>
                    <div class="sp-col">操作</div>
                  </div>
                  <div class="spec-item" v-for="(item, idx) in form.giftData" :key="idx">
                    <el-form-item class="sp-col flex2" label-width="0" :prop="`giftData[${idx}].goodsId`" :rules="{ required: true, message: '请选择', trigger: 'change' }">
                      <el-select v-model="item.goodsId" filterable placeholder="请选择" @change="handleChange(item)" :class="{'unmatched': item.isMatched === false}">
                        <el-option v-for="it in filteredGoods" :key="it.id" :label="`${it.name}(${it.skuCode})`" :value="it.id"></el-option>
                      </el-select>
                      <div v-if="item.isMatched === false" class="off-shelf-tip">已下架</div>
                    </el-form-item>
                    <el-form-item class="sp-col" label-width="0">
                      <span class="spec-text">{{ item.spec || '-' }}</span>
                    </el-form-item>
                    <el-form-item class="sp-col" label-width="0" :rules="{
                        required: true,
                        message: '请填写',
                        trigger: 'change',
                      }">
                      <el-input v-model="item.price" placeholder="请输入商品价格" :disabled="true" />
                    </el-form-item>
                    <el-form-item class="sp-col" label-width="0" :rules="{
                        required: true,
                        message: '请填写',
                        trigger: 'change',
                      }">
                      <el-input v-model="item.discount" placeholder="自动生成" :disabled="true" />
                    </el-form-item>
                    <el-form-item class="sp-col" :prop="`giftData[${idx}].buyNum`" label-width="0" :rules="[
                      {required: true, message: '请填写数量', trigger: 'change'},
                      {validator: validatePositiveInteger, trigger: 'blur'}
                    ]">
                      <el-input v-model="item.buyNum" placeholder="请输入数量" @input="getAllMoney" />
                    </el-form-item>
                    <div class="sp-col oper-icon">
                      <i class="el-icon-minus" @click="handleDeleteItem(idx)"></i>
                      <i class="el-icon-plus" @click="handleAddItem"></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <div class="formMoney" style="margin-bottom:20px">商品总价：¥{{ form.allMoney }}</div>
              <div class="frBox">
                <el-form-item label="快递类型：" class="width50" prop="expressId" :rules="[{ required: true, message: '请选择快递类型', trigger: 'change' },]">
                  <el-select v-model="form.expressId" placeholder="请选择快递类型" clearable @change="changeExpress">
                    <el-option v-for="(it,idx) in deliveryList" :key="idx" :label="it.name" :value="it.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮费：" class="width50" prop="freight" :rules="[
                  { required: true, message: '请填写邮费', trigger: 'blur' },
                  { validator: validateFreight, trigger: 'blur' }
                ]">
                  <el-input v-model="form.freight" placeholder="请输入邮费" :disabled="!form.expressId" @blur="formatFreightOnBlur" />
                </el-form-item>
              </div>

            </template>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="doCreate()" :disabled="isSubmitDisabled">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <addressVue ref="addressVue" @created="createAddr" />
  </div>
</template>
<script>
import goodsOrderApi from "@/api/order/goodsOrder";
import { getGoodsPage, createOrder, getOrderDetail } from '@/api/order/outboundOrder'
import { Subtr, accMul, formatDateStr, getDateAfterNDays } from "@/utils/index";
import addressVue from '@/views/order/goodsorder/address.vue'
import request from '@/utils/request'
function initFormBean() {
  const formBean = {
    discount: undefined,
    giftData: [{ goodsId: "", skuId: "", buyNum: "", price: "", discount: '' }],
    allMoney: 0,
    name: undefined,
    addr: undefined,
    companyName: undefined,
    msg: undefined,
    expressId: undefined,
    freight: undefined,
    orderType: 10,
    orderPayType: 2,
  }
  return formBean
}
export default {
  components: { addressVue },
  props: { visible: { type: Boolean, default: false } },
  data() {
    return {
      deliveryList: [],
      userList: [],
      userAddrList: [],
      customerCertificatesList: [],
      sysGoods: [],
      form: initFormBean(),
      formVisible: false,
      fullscreenLoading: false,
      isRepSub: false,
      userWallet: null,
      customerLevelIds: [],
      loading: false,
      editingId: undefined,
      ratioCache: {},
      goodsLoaded: null,
      searchTimer: null,
      searchSeq: 0,
    };
  },
  watch: {
    visible: { immediate: true, handler(v) { this.formVisible = v } },
    formVisible(v) { this.$emit('update:visible', v) }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    this.getDeliveryList();
    // this.getUserList();
    this.getGoods();

  },
  computed: {
    filteredGoods() {
      let list = this.sysGoods
      // 支付方式过滤
      if (this.form.orderPayType) {
        const m = { 1: '2', 2: '1', 4: '3' }
        const t = m[this.form.orderPayType]
        if (t) list = list.filter(g => (g.buyAccounts || '1,2,3').split(',').includes(t))
      }
      // 角色权限过滤：visibleRoles存的是customer_level的ID,用客户等级匹配
      list = list.filter(g => {
        if (!g.visibleRoles) return true
        const roles = g.visibleRoles.split(',')
        return this.customerLevelIds.some(r => roles.includes(String(r)))
      })
      return list
    },
    isSubmitDisabled() { return false }
  },
  methods: {
    isPaymentDisabled(payType) {
      if (!this.userWallet || !this.totalAmount) return false
      const { tuition, xiaoduMoney, balance } = this.userWallet
      const bal = payType === 1 ? parseFloat(xiaoduMoney) : (payType === 2 ? parseFloat(balance) : parseFloat(tuition))
      return isNaN(bal) || bal < this.totalAmount
    },
    validatePositiveInteger(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请填写数量'));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    },
    validateFreight(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        return callback(new Error('请填写邮费'))
      }
      const num = Number(value)
      if (isNaN(num) || num < 0) {
        return callback(new Error('邮费需≥0，保留2位小数'))
      }
      // 必须保留2位小数
      const str = String(value)
      if (!/^\d+(\.\d{2})$/.test(str)) {
        return callback(new Error('邮费需≥0，保留2位小数'))
      }
      callback()
    },
    formatFreightOnBlur() {
      if (this.form.freight === '' || this.form.freight === null || this.form.freight === undefined) return
      const num = Number(this.form.freight)
      if (!isNaN(num) && num >= 0) {
        this.form.freight = num.toFixed(2)
      }
    },
    addAddress() {
      if (!this.form.name) return this.$message('请选择下单人')
      let find = this.userList.find(item => item.id === this.form.name)
      this.$refs.addressVue.handleShow(find)
    },
    createAddr(id) {
      this.getUserAddr(id)
    },
    // 其他方法不变
    getUserWallet(custId) {
      const id = custId || this.form.name
      if (!id) return
      goodsOrderApi.userWallet(id).then(res => {
        if (res.code === '0') this.userWallet = res.data
      })
    },
    resetForm() {
      this.isRepSub = false
      this.editingId = undefined
      this.userWallet = null
      this.customerLevelIds = []
      this.form = initFormBean()
    },
    getDeliveryList(row) {
      let orderType = "1";
      goodsOrderApi.getDeliveryList({ orderType, isEnable: 1 }).then((res) => {
        let { list } = res.data;
        this.deliveryList = list;
      });
    },
    searchUsers(query) {
      const keyword = (query || '').trim()
      clearTimeout(this.searchTimer)
      if (!keyword) {
        this.loading = false
        this.userList = []
        return
      }
      this.loading = true
      // 防抖:连续输入只发最后一次请求
      this.searchTimer = setTimeout(() => { this.getUserList(keyword) }, 300)
    },
    getUserList(query) {
      // 序号保护:只认最后一次请求的结果,避免乱序返回覆盖
      const seq = ++this.searchSeq
      return goodsOrderApi.getUserList({ state: 1, isDeparted: 0, filterNotCertified: 1, nameOrPho: query, pageNo: 1, pageSize: 100 }).then((res) => {
        if (seq !== this.searchSeq) return
        const list = (res.data && res.data.list) || []
        this.userList = list.map(item => {
          const c = item.customer || {}
          return {
            id: c.id, name: c.name, pho: c.pho, userId: c.userId,
            levelName: (item.customerLevel && item.customerLevel.name) || ''
          }
        }).filter(u => u.id)
      }).finally(() => {
        if (seq === this.searchSeq) this.loading = false
      })
    },
    changeExpress() {
      let { expressId, addr, allMoney, orderPayType } = this.form;
      if (expressId && addr && allMoney && orderPayType) {
        goodsOrderApi.freight({ expressId, addressId: addr, money: allMoney, payType: orderPayType }).then(res => {
          this.form.freight = Number(res.data).toFixed(2);
            })
      }
    },
    handleCreate(row, isEdit) {
      this.resetForm()
      if (isEdit) this.editingId = row.id
      if (row && row.id) {
        getOrderDetail(row.id).then(res => {
          if (res.code === '0') {
            const d = res.data
            this.getUserList(d.customerName || d.customerPhone || '')
            setTimeout(() => {
              const u = this.userList.find(u => u.id === d.customerId)
              if (u) {
                this.form.name = u.id
                request({ url: '/outbound/order/customerLevel/' + u.id, method: 'get' }).then(res => { if (res.code === '0') this.customerLevelIds = res.data || [] })
                this.form.userId = u.userId; this.form.cityId = u.cityId
                this.form.customerPhone = u.pho || d.customerPhone || ''
                // 等地址列表加载完再开弹窗
                ;[1,2,4].forEach(pt => { goodsOrderApi.profitRatioCust({ custId: u.id, payType: pt }).then(r => { if (r.data) { this.ratioCache[pt] = accMul(r.data, 10); this.changeRatio() } }).catch(() => {}) })
                goodsOrderApi.getUserAddrList({ userId: u.userId }).then((res) => {
                  let { list } = res.data
                  if (list.length) list.forEach(it => { it.allAddr = it.country + it.province + it.city + it.district + it.detailedAddress })
                  this.userAddrList = list
                  this.form.addr = d.addressId
                  this.openEditDialog(d)
                })
                goodsOrderApi.getCustomerCertificatesList(u.id).then(res => { this.customerCertificatesList = res.data || [] })
                this.getUserWallet()
                return
              }
              this.form.addr = d.addressId
              this.openEditDialog(d)
            }, 600)
          }
        })
        return
      }
      this.formVisible = true
    },
    openEditDialog(d) {
      this.form.orderType = (d.orderType || 1) * 10
      // 后端支付方式映射到前端: 后1(余额)→前2, 后2(零售价)→前1, 后3(学费)→前4
      const toFrontPayType = { 1: 2, 2: 1, 3: 4 }
      this.form.orderPayType = toFrontPayType[parseInt(d.orderPayType)] || 2
      this.form.msg = d.orderRemark
      this.form.discount = 10
      this.form.freight = d.freight != null ? Number(d.freight).toFixed(2) : 0
      this.form.expressId = d.expressId
      this.form.companyName = d.customerIdcard || ''
      if (d.goodsList && d.goodsList.length) {
        this.form.giftData = d.goodsList.map(g => ({
          goodsId: g.goodsId, buyNum: g.goodsQuantity,
          price: g.goodsPrice, retailPrice: g.retailPrice || g.goodsPrice,
          spec: g.spec || '', discount: 10, isMatched: true, skuId: g.goodsId
        }))
        // 商品列表加载完后标记已下架的商品,提示重新选择
        const markOffShelf = () => {
          this.form.giftData.forEach(item => {
            if (item.goodsId) {
              this.$set(item, 'isMatched', this.sysGoods.some(it => it.id === item.goodsId))
            }
          })
        }
        this.goodsLoaded ? this.goodsLoaded.then(markOffShelf) : markOffShelf()
        this.getAllMoney()
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'] && this.$refs['dataForm'].clearValidate('orderPayType')
        this.changeRatio()
      })
    },
    // 选择事件
    getUserAddr(val) {
      let find = this.userList.find(item => item.id == val)
      if (find) { this.form.userId = find.userId; this.form.cityId = find.cityId; this.form.customerPhone = find.pho || '' }
      // 获取客户等级
      if (val) {
        request({ url: '/outbound/order/customerLevel/' + val, method: 'get' }).then(res => {
          if (res.code === '0') this.customerLevelIds = res.data || []
        })
      }
      ;[1,2,4].forEach(pt => { goodsOrderApi.profitRatioCust({ custId: val, payType: pt }).then(r => { if (r.data) { this.ratioCache[pt] = accMul(r.data, 10); this.changeRatio() } }).catch(() => {}) })
      goodsOrderApi.getUserAddrList({ userId: find ? find.userId : val }).then((res) => {
        let { list } = res.data;
        if (list.length) {
          list.forEach((it) => {
            it.allAddr = it.country + it.province + it.city + it.district + it.detailedAddress;
          });
        }
        this.userAddrList = list;
      });
      goodsOrderApi.getCustomerCertificatesList(val).then((res) => {
        this.customerCertificatesList = res.data;
        this.form.addr = undefined;
      });
      this.changeRatio()
      this.getUserWallet(val)
    },
    changeRatio() {
      const rt = this.ratioCache[this.form.orderPayType]
      this.form.discount = rt || 10
      this.form.giftData.forEach(item => { item.discount = this.form.discount })
      this.getAllMoney()
    },
    getGoods() {
      // state:1 只取已上架的商品,已下架的商品不允许下单选择
      this.goodsLoaded = getGoodsPage({ pageNo: 1, pageSize: 999, state: 1 }).then(res => {
        if (res.code === '0') this.sysGoods = res.data.list
      })
      return this.goodsLoaded
    },
    handleChange(item) {
      let find = this.filteredGoods.find((it) => it.id === item.goodsId);
      item.isMatched = !!find;
      if (find) {
        item.price = find.price;
        item.retailPrice = find.price;
        item.spec = find.spec || '';
        this.$set(item, "skuId", find.id);
      }
      this.getAllMoney()
    },
    handleSpecChange(item, index) {
      item.specArr.forEach((it, idx) => {
        console.log(1111, it, item)
        if (it.id == item.skuId) {
          this.form.giftData[index].price = it.retailPrice;
          this.form.giftData[index].presell = it.surplusStock <= 0 ? 1 : 0;
          this.form.giftData[index].presellTime = item.sendDay && it.surplusStock <= 0 ? formatDateStr(getDateAfterNDays(item.sendDay)) : '';
        }
      });
      this.getAllMoney()
    },
    handleDeleteItem(index) {
      if (this.form.giftData.length <= 1) return;
      this.form.giftData.splice(index, 1);
      this.getAllMoney()
    },
    handleAddItem() {
      this.form.giftData.push({
        goodsId: "",
        skuId: "",
        buyNum: "",
        price: "",
        discount: this.form.discount,
      });
    },
    getAllMoney() {
      let allMoney = 0;
      this.form.giftData.forEach((it) => {
        if (it.buyNum && it.price && it.discount) {
          allMoney = Subtr(
            allMoney,
            -accMul(it.buyNum, accMul(it.price, it.discount * 0.1))
          );
        }
      });
      this.form.allMoney = parseFloat(allMoney).toFixed(2);
      this.changeExpress()
    },
    // 添加订单
    doCreate() {
      if (this.fullscreenLoading) return;
      // 添加余额检查
      if (this.isSubmitDisabled) {
        const { orderPayType } = this.form;
        const { tuition, xiaoduMoney } = this.userWallet;
        
        if (orderPayType === 4 && parseFloat(tuition) <= 0) {
          this.$message.error('赠送支付余额不足，无法提交订单');
          return;
        }
        
        if (orderPayType === 1 && parseFloat(xiaoduMoney) <= 0) {
          this.$message.error('零售价余额不足，无法提交订单');
          return;
        }
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          // 检查是否有未匹配的商品
          const unmatchedGoods = this.form.giftData.filter(item => item.isMatched === false);
          if (unmatchedGoods.length > 0) {
            this.$message.error('存在已下架的商品，请重新选择商品');
            return;
          }

          let { orderPayType, allMoney, freight } = this.form;
          let { tuition, xiaoduMoney, balance } = this.userWallet;
          let price = orderPayType === 1 ? xiaoduMoney : (orderPayType === 2 ? balance : tuition)
          let allAmount = Subtr(allMoney, -freight)
          if (+price < +allAmount) {
            const payName = orderPayType === 1 ? '零售价' : (orderPayType === 2 ? '余额' : '学费')
            this.$alert(`订单总金额：￥${allAmount}<br/>当前${payName}余额：￥${price}<br/>还差：￥${(allAmount - price).toFixed(2)}`, '余额不足', { dangerouslyUseHTMLString: true })
            return
          }
          this.submitForm()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    checkHintOrder() {
      this.$confirm(`<p style="color: red;">请仔细核对以下价格，确认无误后再生成订单！</p>
      <p>商品原价：元</p>
      <p style="color: red;">折扣金额：元</p>
      <p>商品支付金额：元</p>
      <p>邮费支付金额：元</p>
      <p style="color: red;">支付总金额：元</p>`, '支付价格明细提示', {
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.submitForm()
      })
    },
    submitForm() {
      let settleGoodsDtos = [];
      this.form.giftData.forEach((it) => {
        if (it.buyNum && it.discount) {
          var obj = {
            buyNum: it.buyNum,
            goodsId: it.goodsId,
            price: it.price,
            discount: it.discount,
            retailPrice: it.retailPrice || it.price,
            spec: it.spec || '',
            skuId: it.skuId,
            presell: it.presell,
            presellTime: it.presellTime,
          };
          settleGoodsDtos.push(obj);
        }
      });
      // 前端支付方式映射到后端: 前1(零售价)→后2, 前2(余额)→后1, 前4(赠送/学费)→后3
      const payTypeMap = { 1: 2, 2: 1, 4: 3 }
      let query = {
        customerId: this.form.name, userId: this.form.userId,
        customerName: this.form.name ? (this.userList.find(u => u.id === this.form.name) || {}).name : '',
        customerPhone: this.form.customerPhone || '',
        addressId: this.form.addr, customerIdcard: this.form.companyName,
        expressId: this.form.expressId, orderRemark: this.form.msg,
        freight: this.form.freight || 0, orderPayType: payTypeMap[this.form.orderPayType] || this.form.orderPayType,
        orderType: Math.floor(this.form.orderType / 10), cityId: this.form.cityId,
        goodsList: settleGoodsDtos.filter(g => g.buyNum).map(g => ({
            goodsId: g.goodsId,
            goodsQuantity: parseInt(g.buyNum),
            goodsPrice: accMul(g.price, g.discount * 0.1),
            retailPrice: g.retailPrice || g.price,
            spec: g.spec || ''
        }))
      };
      if (this.isRepSub) return
      this.isRepSub = true
      this.fullscreenLoading = true;
      const api = this.editingId
        ? request({ url: '/outbound/order/' + this.editingId, method: 'put', data: query })
        : createOrder(query)
      api.then((res) => {
        if (res.code === '0') {
          this.fullscreenLoading = false;
          this.formVisible = false;
          this.$message.success(this.editingId ? '修改成功' : '下单成功');
          this.$emit("success");
          this.isRepSub = false
        }
      }).catch(res => {
        this.fullscreenLoading = false;
        this.isRepSub = false
      });
    },
    closeDialog() {
      this.formVisible = false;
      this.fullscreenLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.reimbursement {
  padding: 0 20px;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex-grow: 2;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #5dbde7;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
       
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      flex-grow: 2;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.frBox {
  display: flex;
  align-items: center;
  .width50 {
    width: 50% !important;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
.formMoney {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 20px;
  color: #e73f3f;
  .el-button {
    margin-top: 20px;
  }
}
.pays {
  font-size: 10px;
  color: #999;
}
.price-notice {
  font-size: 12px;
  color: #e6a23c;
  background: #fdf6ec;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 15px;
  line-height: 20px;
}
.is-checked .pays {
  color: #999;
}
.select-wrapper {
  position: relative;
  width: 100%;
}

.off-shelf-tip {
  color: #f56c6c;
  font-size: 12px;
  position: absolute;
  left: 8px;
  bottom: -12px;
}

::v-deep .unmatched {
  .el-input__inner {
    border-color: #f56c6c;
  }
}
</style>
